import { render, staticRenderFns } from "./countDown.vue?vue&type=template&id=27829d9a&scoped=true"
import script from "./countDown.vue?vue&type=script&lang=ts"
export * from "./countDown.vue?vue&type=script&lang=ts"
import style0 from "./countDown.vue?vue&type=style&index=0&id=27829d9a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27829d9a",
  null
  
)

export default component.exports